import {Modal, Row, Col, Input, InputNumber, Select} from 'antd';
import {useEffect, useState} from 'react';
import {getBankAccounts} from "../../api/Api";

const {TextArea} = Input;

export const AddPaymentWidget = ({open, remainingBalance, onOk, onCancel, refresh, onApiFail, props}) => {
    const [amount, setAmount] = useState(0);
    const [notes, setNotes] = useState("");
    const [bankOptions, setBankOptions] = useState([]);
    const [bank, setBank] = useState(undefined);

    useEffect(() => {
        getBankAccounts().then(result => {
            setBankOptions(result.map(r => {
                return {
                    key: r.id,
                    value: r.id,
                    label: r.name,
                    account: r
                }
            }));
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }, [onApiFail, refresh])

    const handleOk = () => {
        if (onOk) onOk(amount, bank, notes);
    }

    const handleCancel =() => {
        setAmount(0);
        setBank(undefined)
        setNotes("");
        if (onCancel) onCancel();
    }

    const onAmountChange = (val) => {
        setAmount(val);
    }

    const onNotesChange = (e) => {
        setNotes(e.target.value);
    }

    const onBankChange = (val, option) => {
        setBank(val);
    }

    const rowStyle = {paddingTop: '5px', paddingBottom: '5px'}

    const okDisabled = (amount <= 0) || (amount > remainingBalance) || (bank === undefined);
    const okProps = {
        disabled: okDisabled
    }

    const warningStyle={
        color: 'red'
    }

    let warning;
    if (amount <= 0) {
        warning = <div style={warningStyle}>Payment amount is too low.</div>
    } else if (amount > remainingBalance) {
        warning = <div style={warningStyle}>Payment amount is too high</div>
    } else {
        warning = <div/>
    }

    return <Modal open={open} onOk={handleOk} onCancel={handleCancel} okButtonProps={okProps}>
        <Row style={rowStyle}><Col span={12}>Remaining balance</Col><Col>$ {remainingBalance}</Col></Row>
        <Row style={rowStyle}><Col span={12}><InputNumber min={0} precision={2} placeholder={'amount'} addonBefore={"$"} onChange={onAmountChange} value={amount} /></Col></Row>
        <Row style={rowStyle}><Col span={12}>
            <Select placeholder={'account'} options={bankOptions} onChange={onBankChange} popupMatchSelectWidth={false}/>
        </Col></Row>
        <Row style={rowStyle}><TextArea rows={4} placeholder={"notes"} onChange={onNotesChange} maxLength={64} /></Row>
        <Row style={rowStyle}>{warning}</Row>
    </Modal>
}